// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3YqPB","header":"ReportDetails_header__20jDT","title":"ReportDetails_title__2yQGq","left":"ReportDetails_left__3U2ki"};